<template>
  <div class="wrap" v-loading="loading">
    <div class="place">
      <router-link class="link" to="./">首页</router-link>
      <div class="division">/</div>
      <div class="active">对账单明细</div>
    </div>
    <div class="master" ref="master">
        <el-descriptions class="margin-top" title="帐单信息" :column="2" size="medium">
          <template slot="extra">
            <el-button
              v-if="status == 'A'"
              type="primary"
              size="mini"
              @click="confirm()"
              >确认</el-button
            >
            <el-button type="primary" size="mini" @click="print()">打印</el-button>
          </template>
          <el-descriptions-item label="单号">{{ master.spa_code }}</el-descriptions-item>
          <el-descriptions-item label="日期">{{ master.spa_date }}</el-descriptions-item>
          <el-descriptions-item label="创建人">{{ master.CreateBy }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ master.CreateOn }}</el-descriptions-item>
          <el-descriptions-item label="审核人">{{ master.ApprovedBy }}</el-descriptions-item>
          <el-descriptions-item label="审核时间">{{ master.ApprovedOn }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ master.Status }}</el-descriptions-item>
        </el-descriptions>
    </div>
    <template>
      <el-table
        :data="tableData"
        :style="contentStyleObj"
        border
        fit
        show-summary
        :summary-method="getSummaries"
        @cell-click="openEditColumn"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column prop="doc_type" label="单据类型"> </el-table-column>
        <el-table-column prop="doc_no" label="相关单号"> </el-table-column>
        <el-table-column prop="bi_type" label="业务类型"></el-table-column>
        <el-table-column prop="bi_code" label="业务单号"></el-table-column>
        <el-table-column prop="item_code" label="货品编码"> </el-table-column>
        <el-table-column prop="item_name_cn" label="中文名称"> </el-table-column>
        <el-table-column prop="carMod" label="车型"> </el-table-column>
        <el-table-column prop="OEMCode" label="原厂编码"> </el-table-column>
        <el-table-column prop="brand" label="商品品牌"> </el-table-column>
        <el-table-column prop="item_qty" label="数量"> </el-table-column>
        <el-table-column prop="unit_price" label="单价/调控差价"> </el-table-column>
        <el-table-column cell-style="fact_init" prop="fact_sum" label="金额"> </el-table-column>
        <el-table-column prop="item_sn" label="破损序列号"> </el-table-column>
        <el-table-column prop="remark" label="备注"> </el-table-column>
        
      </el-table>
    </template>
  </div>
</template>
<script>
export default {
  name: "order_detail",
  props:['param'],
  data() {
    return {
      contentStyleObj: {
        height: "",
        "min-width": "1400px",
        overflow: "auto",
      },
      params: this.$route.params,
      tableData: [],
      status: "",
      master: [],
      loading: false,
      cell_style: {
        "text-align": "center",
      },
    };
  },
  async created() {
    this.loading = true;
    await this.getData();
    this.loading = false;
    this.tableData.forEach((item) => {
      item.Edit = false;
    });
  },
  mounted(){
    this.getHeight();
  },
  methods: {
    async getData() {
      // let params = this.params;
      let params = JSON.parse(this.param);
      let res = await this.$Http.getSpaDetail(params);
      if (res.code == 0) {
        res.data.data.forEach((item) =>{
          item.Edit = false;
          this.tableData.push(item);
        })
        this.status = res.data.status;
        this.master = res.data.master;
      } else {
        this.$message.error(res.msg);
      }
    },
    //设置窗口高度
    getHeight() {
      // console.log(this.$refs.master.offsetHeight);
      this.contentStyleObj.height = window.innerHeight - 120 - 70 - 15 - this.$refs.master.offsetHeight + "px";
    },
    /**
     * 确认
     */
    confirm() {
      this.$confirm("是否确认对账单？", "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // let params = this.params;
          let params = JSON.parse(this.param);
          let res = await this.$Http.spaConfirm(params);
          if (res.code == 0) {
            this.$message({
              message: "确认成功",
              type: "success",
            });
            this.getData();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    /**
     * 打印
     */
    print() {
      let params = JSON.parse(this.param);
      let url =
        this.GLOBAL.basic_url +
        "sr_scm/printSpa?dept_id=" +
        params.dept_id +
        "&spa_code=" +
        params.spa_code;
      window.open(url);
    },
    //合计方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        sums[index] = "";
        if (column.property == "item_qty") {
          const values = data.map((item) => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
        if (column.property == "fact_sum") {
          const values = data.map((item) => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0).toFixed(2);
        }
      });
      return sums;
    },
    // 打开信息编辑
    openEditColumn(row, column) {
      if(this.status!='A'){
        return 
      }
      if (column.property === "supplier_remarks") {
        let refName='';
        this.tableData.forEach((item,index) => {
          if (item.ROW_NUMBER === row.ROW_NUMBER) {
            row.Edit = true;
            // 激活当前点击的单元格进入可以编辑（span与el-input标签显示隐藏切换）
            this.$set(this.tableData,index,row);
            refName = 'input'+row.ROW_NUMBER;
            // this.$refs['input'+row.ROW_NUMBER].focus();
          }
        });
        setTimeout(()=>{
          this.$refs[refName].focus();
        },1)
      }
    },
    // 表格数据编辑保存并关闭编辑
    async editColumnData(row) {
      // 关闭表格编辑
      this.tableData.forEach((item,index) => {
        if (item.ROW_NUMBER === row.ROW_NUMBER) {
            row.Edit = false;
            this.$set(this.tableData,index,row);
        }
      });
      let param = JSON.parse(this.param);
      let params = {
        dept_id: param.dept_id,
        spa_code: param.spa_code,
        seq_no: row.seq_no,
        supplier_remarks: row.supplier_remarks
      }
      // let res = await this.$Http.updateSupplier_remarks(params);
      await this.$Http.updateSupplier_remarks(params);
    },
  },
};
</script>

<style scoped>
.wrap {
  padding: 0 20px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  text-align: center;
}
.place {
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.division {
  padding: 0 5px;
  color: #c0c4cc;
}
.btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
  text-align: left;
}
.el-table::before{
  height: 0 !important;
}
</style>